"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var Icon_1 = require("../../Icon");
var getClassNames = Utilities_1.classNamesFunction();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardStatusBase = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentCardStatusBase, _super);
    function DocumentCardStatusBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardStatusBase.prototype.render = function () {
        var _a = this.props, statusIcon = _a.statusIcon, status = _a.status, styles = _a.styles, theme = _a.theme, className = _a.className;
        var iconProps = {
            iconName: statusIcon,
            styles: {
                root: { padding: '8px' }
            }
        };
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (React.createElement("div", { className: this._classNames.root },
            statusIcon && React.createElement(Icon_1.Icon, tslib_1.__assign({}, iconProps)),
            status));
    };
    return DocumentCardStatusBase;
}(Utilities_1.BaseComponent));
exports.DocumentCardStatusBase = DocumentCardStatusBase;
//# sourceMappingURL=DocumentCardStatus.base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCardStatus.base.js
// module id = 971
// module chunks = 0